module.exports = __webpack_public_path__ + "img/KI.d813b860.svg";